import React, { useState, useEffect, useRef } from 'react';
import { TooltipWidget } from 'anf-core-react';

export default function GarmentMeasurement({
  measurementSize = '',
  measurementText = '',
  tooltipHeader = '',
  tooltipText = '',
}) {
  const tooltipRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef?.current && !tooltipRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleTooltipKeyUp = (event) => {
    event.stopPropagation();
    if (event.key === 'Escape') {
      setIsOpen(false);
    } else if (['Space', 'Return'].includes(event.key)) {
      setIsOpen(!isOpen);
    }
  };

  if (!measurementSize) return null;

  const hasTooltip = (!!tooltipHeader && !!tooltipText);

  const renderTooltip = () => (
    <div ref={tooltipRef}>
      <TooltipWidget
        contentPosition="top-center"
        buttonLabelText={measurementText}
        contentID="story-tooltip"
        isOpen={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        onKeyUp={(e) => handleTooltipKeyUp(e)}
      >
        <div
          className="garment-measurement__tooltip-container"
        >
          <h3>{tooltipHeader}</h3>
          <p>{tooltipText}</p>
        </div>
      </TooltipWidget>
    </div>
  );

  return (
    <div className={`garment-measurement ${hasTooltip ? 'garment-measurement--space-between' : ''}`}>
      <div className="garment-measurement__label-wrapper">
        <p className="garment-measurement__measurement-text">{`${measurementText}:`}</p>
        {hasTooltip && renderTooltip()}
      </div>
      {' '}
      <p className="garment-measurement__measurement-size">{`${measurementSize}`}</p>
    </div>
  );
}
